module.exports = __webpack_public_path__ + "img/jeweller@2x.dd64cdf.webp";